import { Text, View } from '@react-pdf/renderer';

const Hobbies = ({ styles, data = [], headerTitle }: any) => {
	return (
		<View style={styles.mainBox}>
			<Text style={styles.heading}>{headerTitle}</Text>
			<View style={styles.skills}>
				{data?.map((res: any, index: number) => (
					<View style={styles.skillsBox}>
						<Text key={index} style={styles.skillsText}>
							{res}
						</Text>
					</View>
				))}
			</View>
		</View>
	);
};

export default Hobbies;
